import { useCallback } from 'react';
import { useRouter } from 'next/navigation';

/**
 * Hook to handle smooth scrolling to a section on the page.
 * @param sectionId The ID of the section to scroll to
 */
export function useScrollToSection(sectionId: string) {
  const router = useRouter();

  return useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      const section = document.querySelector(sectionId);

      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        router.push(sectionId, { scroll: false });
      }
    },
    [router, sectionId],
  );
}
